'use client';

import dynamic from 'next/dynamic';

const SplashScreen = dynamic(
  () =>
    import('./SplashScreen').then((mod) => ({
      default: mod.SplashScreen,
    })),
  { ssr: false },
);

interface SplashScreenWrapperProps {
  targetDate: Date;
}

export const SplashScreenWrapper = ({ targetDate }: SplashScreenWrapperProps) => {
  return <SplashScreen targetDate={targetDate} />;
};
